<template>
    <div class="group relative">
        <!-- eslint-disable-next-line vue/no-v-html - html is pre-sanitized by parent -->
        <div v-html="html" />
        <BaseButton
            theme="neutral"
            size="sm"
            class="absolute top-0 right-0 inline-flex items-center gap-1 hover-capable:opacity-0 hover-capable:group-hover:opacity-100 focus-visible:opacity-100"
            @click="handleCopy">
            <Copy class="w-3 h-3" aria-hidden="true" />
            {{ isCopied ? t("components.copyableBlock.copied") : t("components.copyableBlock.copy") }}
        </BaseButton>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import { useTimedShow } from "~vue/composables/useTimedShow";
import Copy from "~vue/icons/Copy.vue";
import { logUserInteraction } from "~vue/utils/logUtils";
import { inject, onMounted } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

interface Props {
    content: string;
    html: string;
    blockIndex: number;
    messageId?: number;
}

const props = defineProps<Props>();
const coachingSessionUuid = inject<string>("coachingSessionUuid");
const { show: showCopied, isShowing: isCopied } = useTimedShow({ duration: 2000 });

onMounted(() => {
    logUserInteraction("copyable_block_shown", { chat_message_id: props.messageId, block_index: props.blockIndex }, coachingSessionUuid);
});

const handleCopy = async () => {
    await navigator.clipboard.writeText(props.content);
    showCopied();
    logUserInteraction("copyable_block_copied", { chat_message_id: props.messageId, block_index: props.blockIndex, content_length: props.content.length }, coachingSessionUuid);
};
</script>
